import { log } from '@/utils'
import { withAuth0, WithAuth0Props } from '@auth0/auth0-react'
import * as Sentry from '@sentry/react'
import React, { useEffect, ReactNode } from 'react'
import { Header } from '../molecules/Header'
import { ErrorView } from '../organisms/ErrorView'
import { PageLayout } from '../styled'

interface ErrorBoundaryFallbackProps extends WithAuth0Props {
  error: Error
  componentStack: string
  resetError: () => void
}

const ErrorBoundaryFallback: React.FC<ErrorBoundaryFallbackProps> = ({
  error,
  componentStack,
  resetError,
}) => {
  const handleBack = () => {
    window.history.back()
    resetError()
  }

  useEffect(() => {
    log(error.toString(), componentStack)
  }, [])

  return (
    <PageLayout simple>
      <Header simple />
      <ErrorView onBack={handleBack} />
    </PageLayout>
  )
}

const WrappedErrorBoundaryFallback = withAuth0(ErrorBoundaryFallback)

interface ErrorBoundaryProps {
  children: ReactNode
}

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
  const fallback: Sentry.FallbackRender = ({
    error,
    componentStack,
    resetError,
  }) => (
    <WrappedErrorBoundaryFallback
      error={error as Error}
      componentStack={componentStack}
      resetError={resetError}
    />
  )

  return (
    <Sentry.ErrorBoundary
      beforeCapture={(scope) => {
        scope.setTag('url', window.location.href)
      }}
      fallback={fallback}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}
